export const environment = {
  production: true,
  sentry: 'https://855a40e3ffe2c57bb61395d5e3bef104@o446789.ingest.us.sentry.io/4509591835574272',
  name: 'Production',
  apiUrl: 'https://warehouse.crownbasenxt.be/api',
  lastAppCookieDomain: 'crownbasenxt.be',
  lastAppCookieName: 'rc_last_app',
  auth0: {
    domain: 'royalcrown.eu.auth0.com',
    clientId: 'eZlxVXcLBvNTKbInqsc3UWW78TGp017V',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://prod.api.royalcrown.be/',
      logoutUrl: window.location.origin,
    },
    useRefreshTokens: true,
    httpInterceptor: {
      allowedList: [
        {
          // Match any request that starts 'https://{yourDomain}/api/v2/' (note the asterisk)
          uri: `https://warehouse.crownbasenxt.be/api/*`,
          tokenOptions: {
            authorizationParams: {
              // The attached token should target this audience
              audience: 'https://prod.api.royalcrown.be/',
              scope: 'openid profile email offline_access',
            },
          },
        },
      ],
    },
  },
};
